import React from 'react';
import { ReactComponent as Trash } from '../../../../../common/images/bin.svg';
import { FontList } from '../../../../../common/ui/Common';

function List({ news = [], onDelete }) {
  return (
    <FontList news>
      <p>Список загруженных новостей</p>
      <ul>
        {news.map((el) => (
          <li key={el.id}>
            <div className="content">
              <p className="titleNews">{el.title}</p>
              <p>{el.text}</p>
              <p className="date">{el.date}</p>
            </div>
            <div>
              <span onClick={() => onDelete(el.id)}><Trash /></span>
            </div>
          </li>
        ))}
      </ul>
    </FontList>
  );
}

export default List;
